export class PrevalentSettingEventAndAntecedent {
  index?: number;
  prevalent_setting_event_and_antecedent: string = '';
  behavior: string[] = [];
  hypothesized_functions: string = '';

  constructor(data: Partial<PrevalentSettingEventAndAntecedent> = {}) {
    this.index = data.index;
    this.prevalent_setting_event_and_antecedent =
      data.prevalent_setting_event_and_antecedent ?? '';
    this.behavior = data.behavior ?? [];
    this.hypothesized_functions = data.hypothesized_functions ?? '';
  }

  static getDeafult(): PrevalentSettingEventAndAntecedent {
    return {
      index: undefined, // Changed from 0
      prevalent_setting_event_and_antecedent: '',
      behavior: [],
      hypothesized_functions: '',
    };
  }

  static getDefaults(): PrevalentSettingEventAndAntecedent[] {
    return [
      {
        index: 1,
        prevalent_setting_event_and_antecedent:
          'This behavior may be displayed when attention is withdrawn or denied.',
        behavior: [],
        hypothesized_functions: 'Attention',
      },
      {
        index: 2,
        prevalent_setting_event_and_antecedent:
          'This behavior may be displayed when any demand given is sustained or something in the environment changed and {name} receives new instructions to follow.',
        behavior: [],
        hypothesized_functions: 'Escape',
      },
      {
        index: 3,
        prevalent_setting_event_and_antecedent:
          'This behavior may be displayed when access to task/activities was denied or delayed, or when {name} is told "no".',
        behavior: [],
        hypothesized_functions: 'Tangible/access',
      },
      {
        index: 4,
        prevalent_setting_event_and_antecedent:
          'This behavior may be displayed as a means of automatic reinforcement.',
        behavior: [],
        hypothesized_functions: 'Automatic',
      },
    ];
  }
}
